<template>
  <MonitorWrapper class="single-mode">
    <div class="mod-top">
      <border-comp2>
        <div class="value-box">
          <div class="value-item" v-for="(v, i) in valueOp" :key="i">
            <div class="item-title">
              <em class="icon iconfont icon-rongyupingbi"></em>
              <span>{{ v.title }}</span>
            </div>
            <div class="item-value">{{ getTitle(v) }}{{ v.unit || '' }}</div>
          </div>
        </div>
      </border-comp2>
    </div>
    <el-row :gutter="20" class="mod-bottom">
      <el-col :span="10">
        <border-comp2>
          <div class="left-icon">
            <div class="icon-box" :class="{ 'flex-space': imsVisible }">
              <slot v-bind:singleDeviceDetail="wsData"></slot>
              <div class="ims-chart" v-if="imsVisible">
                <v-chart :options="initImsOp" :autoresize="true"></v-chart>
              </div>
            </div>
          </div>
        </border-comp2>
      </el-col>
      <el-col :span="14">
        <border-comp2>
          <div class="right-chart">
            <div
              v-for="(v, i) in rightEchart"
              :key="i"
              :style="{ overflow: 'hidden', height: `${96 / rightEchart.length}%` }"
            >
              <v-chart :options="v" :autoresize="true"></v-chart>
            </div>
          </div>
        </border-comp2>
      </el-col>
    </el-row>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import BorderComp2 from '@/components/border-comp2';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import { imsEchart } from '@/echartOption/ims';

export default {
  name: 'SingleMode',
  mixins: [singleDeviceMixin],
  components: {
    BorderComp2
  },
  props: {
    valueOp: {
      type: Array,
      required: true
    },
    mod: {
      type: String,
      required: true
    },
    rightEchart: {
      type: Array,
      required: true
    },
    imsVisible: {
      type: Boolean,
      default: false
    },
    upFn: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      wsData: {},
      count: 0,
      initImsOp: imsEchart()
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas'])
  },
  methods: {
    getTitle(v) {
      const { mods } = this.wsData;
      if (!mods) return 0;
      if (v.format) return v.format(this.wsData);
      return mods[this.mod] && (mods[this.mod][v.key] || 0);
    },
    upCharts(newVal) {
      if (this.upFn) {
        this.upFn(newVal);
        return;
      }
      this.rightEchart.forEach((v, i) => {
        v.series[0].data.push([newVal.beginTime, newVal.mods[this.mod][this.valueOp[i].key]]);
        if (v.series[0].data.length > 20) {
          v.series[0].data.shift();
        }
      });
    },
    updateData(newVal) {
      this.wsData = this.singleDeviceDetail;
      if (newVal && newVal.mods && newVal.mods[this.mod]) {
        this.upCharts(newVal);
        if (this.imsVisible) {
          const ims = newVal.mods['cwaMod'].ims;
          const imsArray = ims.map((e, i) => {
            return [newVal.beginTime, `ims${i + 1}`, e];
          });
          this.count++;
          this.initImsOp.dataset.source.push(...imsArray);
          if (this.count > 20) {
            this.initImsOp.dataset.source.splice(0, 16);
          }
        }
      }
    },
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId || this.$route.params.eventId);
        this.wsData = this.historyDetailData;
        this.historyDetailDatas.forEach(ele => {
          this.rightEchart.forEach((v, i) => {
            v.series[0].data.push([ele.beginTime, ele.mods[this.mod][this.valueOp[i].key]]);
            if (v.series[0].data.length > 20) {
              v.series[0].data.shift();
            }
          });
          if (this.imsVisible) {
            const ims = ele.mods['cwaMod'].ims;
            const imsArray = ims.map((e, i) => {
              return [ele.beginTime, `ims${i + 1}`, e];
            });
            this.initImsOp.dataset.source.push(...imsArray);
          }
        });
        this.hideLoading();
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss">
.single-mode {
  height: 100%;
  padding: 0 20px;
  .mod-top {
    height: 150px;
    margin-bottom: 20px;
  }
  .mod-bottom {
    height: calc(100% - 170px);
    .el-col {
      height: 100%;
    }
  }
  .value-box {
    display: flex;
    height: 100%;
    align-items: center;
    background: url('~@/assets/image/dividing-line.png') no-repeat center center;
    background-color: var(--device-panel-bg);
    .value-item {
      flex: 1;
      text-align: center;
      .item-title {
        font-size: 24px;
        font-weight: bold;
        color: var(--device-title-color);
        em {
          font-size: 24px;
          margin-right: 10px;
        }
      }
      .item-value {
        font-size: 36px;
        font-weight: bold;
        color: var(--device-value-color);
      }
    }
  }
  .left-icon {
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    .icon-box {
      height: 100%;
      box-sizing: border-box;
      padding: 20px;
      background-color: var(--device-panel-bg2);
      &.flex-space {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .ims-chart {
        height: calc(100% - 250px);
        overflow: hidden;
      }
    }
  }
  .right-chart {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    > div {
      background-color: var(--device-panel-bg2);
    }
  }
}
</style>
